import { HorizontalTabLinkProps } from '../../../components'
import * as ROUTES from '../../../routes/constants/routeConstants'
import { EmailsAndSMS } from '../tabs/emails-and-sms'
import { Letters } from '../tabs/letters'
import { News } from '../tabs/news'

// TODO change this to const MESSAGES_TAB_PROPS, when admin tool is in use
export const getMessagesTabProps = (
  showNews: boolean
): HorizontalTabLinkProps[] => [
  {
    exact: false,
    infoBoxProps: {
      translationId: 'pages.messagesPage.emailsAndSms.informationText'
    },
    key: 'emails-and-sms',
    tab: ROUTES.MESSAGES_TAB_EMAILS_AND_SMS,
    to: ROUTES.ROUTE_MESSAGES_EMAILS_AND_SMS,
    translationId: 'pages.messagesPage.emailsAndSms.label',
    TabElement: EmailsAndSMS
  },
  {
    exact: false,
    infoBoxProps: {
      translationId: 'pages.messagesPage.letters.informationText'
    },
    /* TODO: remove isHidden property when letters are in use, 
    change to true if you want to test letters locally */
    isHidden: true,
    key: 'letters',
    tab: ROUTES.MESSAGES_TAB_LETTERS,
    to: ROUTES.ROUTE_MESSAGES_LETTERS,
    translationId: 'pages.messagesPage.letters.label',
    TabElement: Letters
  },
  {
    infoBoxProps: {
      translationId: 'pages.messagesPage.news.informationText'
    },
    exact: false,
    // TODO: remove when admin tool is in use everywhere
    isHidden: !showNews,
    key: 'news',
    tab: ROUTES.MESSAGES_TAB_NEWS,
    to: ROUTES.ROUTE_MESSAGES_NEWS,
    translationId: 'pages.messagesPage.news.label',
    TabElement: News
  }
]
